import inView from 'in-viewport'
import React, { Component } from 'react'
import numeral from 'numeral'

class CountItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      count: props.to,
      increment: Math.ceil(props.to / 40),
    }
  }

  componentDidMount = () => {
    this.setState(state => ({
      ...state,
      count: 0,
    }), () => {
      inView(this.refs.el, () => {
        this.interval = setInterval(this.tick.bind(this), 40)
      })
    })
  }

  tick() {
    if (this.state.count + this.state.increment >= this.props.to) {
      this.setState(state => ({
        ...state,
        count: this.props.to,
      }))

      return clearInterval(this.interval)
    }

    return this.setState(state => ({
      ...state,
      count: state.count + this.state.increment,
    }))
  }

  render() {
    return (
      <div ref="el" className={`${this.props.className}`}>
        { numeral(this.state.count).format('0,0') }{ this.props.suffix || '' }
      </div>
    )
  }
}

CountItem.defaultProps = {
  to: 0,
  className: '',
}

export default CountItem
